'use strict';

import * as Interfaces from '../interfaces/models.interfaces';

export class VoterFraudIncident implements Interfaces.VoterFraudIncident {
    IncidentID: number;
    StateID: number;
    CategoryID: number;
    AllegationSummary: string;
    AllegationDetail: string;
    AllegationType: string;
    AffidavitDesc: string;
    IncidentWeightDesc: string;
    PotentialImpactDesc: string;
    VeracityScoreDesc: string;
    NumberOfVotesAffected: string;
    IncidentSummary: string;
    IncidentComments: string;
    LastUpdate: Date;
}

export class Params {
  stateID: string;
  categoryID: string;
}


export class UserID_Params {
    UserID: number;
}

export class ShortsPosts implements Interfaces.ShortsPosts {
    TSID: number;
    UserID: number;
    PostType: number;
    OriginalPostID: number;
    ParentPostID: number;
    PublishDate: Date;
    PostTitle: string;
    PostContent: string;
    FileName: string;
    VideoURL: string;
    VideoMimeType: string;
    UserName: string;
    ProfileName: string;
    UserImg: string;
    TrustLevel: string;
    SubscriptionLevel: string;
    OrigUserID: number;
    OrigUserName: string;
    OrigUserImg: string;
    OrigProfileName: string;
    OrigPublishDate: Date;
    MediaDirectory: string;
    ImageDirectory: string;
    IsFollowed: boolean;
    IsMuted: boolean;
    MediaItemsJson: string;
    Reactions: Interfaces.Reactions;
    QuotedPosts: Interfaces.QuotedPost;
    ScoreDetailsList: Interfaces.ScoreDetails[]; // New property
    MediaItems: Interfaces.PostMedia[]; 

    replies: ShortsPosts[] = []; // Stores nested replies
    MoreReplies: number = 0; // Indicates how many more replies exist
    showMore: boolean = false; // Indicates if more replies exist

    constructor(rawPost: ShortsPosts) {
        // Assign all other properties from the rawPost object
        Object.assign(this, rawPost);

        //console.log('Constructor rawPost:', rawPost); // Log the input to the constructor
        //console.log('Constructor Raw Media Items:', rawPost.MediaItemsJson); // Log the input to the constructor

        if (!Array.isArray(this.ScoreDetailsList)) {
            this.ScoreDetailsList = [];
        }
        this.MediaItems = [];

        // Ensure QuotedPosts is initialized
        if (!this.QuotedPosts) {
            this.QuotedPosts = {} as Interfaces.QuotedPost; // Initialize QuotedPosts
        }

        // Ensure QuotedMediaItems is initialized
        if (!this.QuotedPosts.QuotedMediaItems) {
            this.QuotedPosts.QuotedMediaItems = [];
        }

        // Process MediaItemsJson if available
        if (rawPost?.MediaItemsJson) {
            const rawMediaItems = JSON.parse(rawPost.MediaItemsJson);
            this.initializeMediaItems(rawMediaItems);
        /*    console.log('Processed Media Item:', this.MediaItems); // Log processed item*/
        }
        //    console.log('Processed Media Item:', this.MediaItems); // Log processed item

        // Process QuotedMediaItemsJson if available
        if (rawPost?.QuotedPosts?.QuotedMediaItemsJson) {
            const rawMediaItems = JSON.parse(rawPost.QuotedPosts.QuotedMediaItemsJson);
            this.initializeQuotedMediaItems(rawMediaItems);
        }

        // Initialize replies if provided
        if (rawPost?.replies) {
            this.replies = rawPost.replies.map(reply => new ShortsPosts(reply));
        }

        // Set "Show More" flag if additional replies exist
        this.MoreReplies = rawPost.MoreReplies || 0;
        this.showMore = this.MoreReplies > 0;
    }

    private initializeMediaItems(rawItems: any[]): void {
        //console.log('Raw Media Items:', rawItems); // Log raw items to confirm input
        this.MediaItems = rawItems.map((item: any) => {
            return {
                fileName: item.FileName || item.fileName || '',
                mimeType: item.MimeType || item.mimeType || '',
                mediaSource: item.MediaSource || item.mediaSource || '',
                mediaUrl: item.MediaUrl || item.mediaUrl || '',
                mediaAnimatedUrl: item.MediaAnimatedUrl || item.mediaAnimatedUrl || '',
                isTenor: (item.MediaSource || item.mediaSource) === 'url',
                isPlaying: false,
            };
        });
    //    console.log('Processed Media Items:', this.MediaItems); // Log processed items
    }
    private initializeQuotedMediaItems(rawItems: any[]): void {
        this.QuotedPosts.QuotedMediaItems = rawItems.map((item: any) => {
            return {
                fileName: item.FileName || item.fileName || '',
                mimeType: item.MimeType || item.mimeType || '',
                mediaSource: item.MediaSource || item.mediaSource || '',
                mediaUrl: item.MediaUrl || item.mediaUrl || '',
                mediaAnimatedUrl: item.MediaAnimatedUrl || item.mediaAnimatedUrl || '',
                isTenor: (item.MediaSource || item.mediaSource) === 'url',
                isPlaying: false,
            };
        });
    }

}

export class PostMedia implements Interfaces.PostMedia {
    fileName: string;
    mimeType: string;
    mediaSource: string;
    mediaUrl: string;
    mediaAnimatedUrl: string; // URL or path to the media file
    isTenor?: boolean = false; // Derived field
    isPlaying?: boolean = false; // Derived field
}

export class ScoreDetails implements Interfaces.ScoreDetails {
    ScoreUserID: string;
    ScoreTypeID: number;
    ScoreType: string;
    Score: number;
    HexColor: string;
    ReasonDetails: Interfaces.ReasonDetail[]; // List of reason details

    constructor() {
        this.ReasonDetails = [];
    }
}

export class ReasonDetail implements Interfaces.ReasonDetail {
    ReasonDetailText: string;
    ReasonLink: string;
}

export class SearchResult implements Interfaces.SearchResult {
    //TSID?: number;
    MatchedText?: string;
    Type?: string; // "Post" or "User"
    UserID?: number;
    UserImg?: string;
    UserName?: string;
    ProfileName?: string;
}

export class ShortsPostSave implements Interfaces.ShortsPostSave {
    UserID: number;
    PostType: number;
    OriginalPostID: number;
    ParentPostID: number;
    PublishDate: Date;
    PostContent: string;
    FileName: string;
    VideoMimeType: string;
    ReplyType?: number;
}

export class Verification implements Interfaces.Verification {
    Name: string;
    ValidationType: string;
    Email: string;
    Phone: string;
    MessageBody: string;
}

export class CodeVerificationRequest implements Interfaces.CodeVerificationRequest {
    Email: string;
    Code: string;
}

// Define interfaces to reflect the C# data models
export class RegistrationData implements Interfaces.RegistrationData {
    LoginInfo: LoginModel;
    UserInfo: UserModel;
}

export class LoginModel implements Interfaces.LoginModel {
    Username: string;
    Password: string;
    PasswordHash?: string;  // Include this if it's sent from the client, otherwise, remove it
    Email: string;
    Phone: string;
    VerificationLevel: number;
    ValidationCode?: string;  // Optional, depending on your implementation
}

export class UserModel implements Interfaces.UserModel {
    UserID?: number;  // Optional, usually not set by client but by database on insert
    Name: string;
    ProfileBio?: string;  // Optional
    Birthday: string;
    Gender: string;
    RegistrationDate?: string;  // Optional, usually set by the server
    IPAddress?: string;  // Optional
    TrustLevel?: number;
    UserImg?: string;
    EntityType?: number;
}

export class ProfileModel implements Interfaces.ProfileModel {
    UserID: number = 0;
    UserName: string = '';
    ProfileName: string = '';
    ProfileBio: string = '';
    Location: string = '';
    URL: string = '';
    BirthDate: string;
    RegistrationDate: string;
    UserImg: string;
    UserBannerImg: string;
    ImageDirectory: string;
    FollowingCount: number;
    FollowersCount: number;
    FreedomScore: number | null;
    FreedomConfidenceScore: number | null;
    FreedomScoreColor: string;
    TruthScore: number | null;
    TruthConfidenceScore: number | null;
    TruthScoreColor: string;
    PoliticalScore: number | null;
    PoliticalConfidenceScore: number | null;
    PoliticalScoreColor: string;
    TransparencyScore: number | null;
    TransparencyConfidenceScore: number | null;
    TransparencyScoreColor: string;
}


export class AuthResponse implements Interfaces.AuthResponse {
    authenticated: boolean;
}

export class UserStatuses implements Interfaces.UserStatuses {
    IsFollowed: boolean;
    IsMuted: boolean;
    IsBlocked: boolean;
}

// Menu Classes
export class TrendingTopic implements Interfaces.TrendingTopic {
    hashtag: string;
    totalEngagement: number;
}

export class UserSuggestion implements Interfaces.UserSuggestion {
    userId: number;
    userName: string;
    profileName: string;
    profileImage: string;
    mutualConnections: number;
}

export class SponsoredPost implements Interfaces.SponsoredPost {
    postId: number;
    userId: number;
    userName: string;
    profileName: string;
    content: string;
    mediaUrl?: string;
    linkUrl?: string;
    advertiserName: string;
}


